"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TipMessage = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Message = require("../Message");
var _getPrefixCls = require("../../utils/getPrefixCls");
var TipMessage = function TipMessage(props) {
  if (!props.content) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Message.Message, (0, _extends2.default)({}, props, {
    className: (0, _getPrefixCls.getPrefixCls)('tip-message')
  }));
};
exports.TipMessage = TipMessage;